
import { gastosCategoriaRepository } from "../infrastructure/supabase/gastosCategoria.repository.js";

export async function listarCategoriasGastoUseCase(filtros) {
  return await gastosCategoriaRepository.listar(filtros);
}
